import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import RadioInput from "./RadioInput";
import WizardFooter from "./WizardFooter";
export const fields = ["unemployed_four_weeks"];

const validate = (values, props) => {
  const errors = {};
  if (!values.unemployed_four_weeks) {
    errors.unemployed_four_weeks = props.allText.shared.required;
  }
  return errors;
};

export const WizardFormSection02 = props => {
  const {
    allText,
    fields: { unemployed_four_weeks },
    handleSubmit,
    previousPage,
  } = props;
  const text = { ...allText.shared, ...allText.section02 };
  const progress = 1;
  return (
    <form onSubmit={handleSubmit} className="form-horizontal">
      <div className="wizard-page-content">
        <div className="page-title-container">
          <span className="page-title underline">{text.title}</span>
          <span className="wizard-text question-text">{text.subtitle}</span>
        </div>
        <div className="single-question-margin">
          <div className="primary-question">{text.primaryQuestion}</div>
          <RadioInput text={text} field={unemployed_four_weeks} />
        </div>
      </div>
      <WizardFooter
        text={text}
        previousPage={previousPage}
        progress={progress}
      />
    </form>
  );
};

WizardFormSection02.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection02);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection02.js